import SmsAccount from "@/types/SmsAccount.interface"

interface State {
    availableNumbers: number[]
    smsAccount: SmsAccount
}

const defaults = () => {
    return {
        availableNumbers: null,
        smsAccount: null
    }
}
export default {
    state: defaults(),
    mutations: {
        smsAccountSet (state: State, smsAccount: SmsAccount): void {
            state.smsAccount = smsAccount
        },
        availableNumbersSet (state: State, numbers: number[]): void {
            state.availableNumbers = numbers
        },
        smsAccountReset (state: State): void {
            Object.assign(state, defaults())
        }
    },
    actions: {
        availableNumbersGet({ commit, getters }, areacode: number): Promise<number[]> {
            //  Assemble the API endpoint
            const url = `${getters.api}/sms-account/search?country=US&areacode=${areacode}`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Set our available numbers
                commit('availableNumbersSet', response.data)

                //  Return the available numbers to the client
                return response.data
            }).catch(() => null)
        },
        availableNumbersProvision ({ commit, getters }, number: number): Promise<boolean> {
            //  Create our payload
            const payload = {
                msisdn: number
            }

            //  Assemble the aPI endpoint
            const url = `${getters.api}/sms-account/provision`

            //  Send the request
            return window.axios.post(url, payload).then(response => {
                //  Set our sms account with the updated information
                commit('smsAccountSet', response.data)

                //  REturn true for successful
                return true
            }).catch (() => null)
        },
        smsAccountGet ({ commit, getters }): Promise<SmsAccount> {
            //  Assemble the API endpoint
            const url = `${getters.api}/sms-account/account`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Set the found sms account
                commit('smsAccountSet', response.data)

                //  Return our found sms account
                return response.data
            }).catch(() => null)
        },
        smsAccountForward ({ getters }, number: number): Promise<SmsAccount> {
            //  Assemble our API endpoint
            const url = `${getters.api}/sms-account/forward`

            //  Send the request
            return window.axios.post(url, number).then(response => {
                //  Return our updated sms account
                return response.data
            }).catch(() => null)
        },
        smsAccountForwardDelete ({ getters }): Promise<SmsAccount> {
            //  Assemble the API endpoint
            const url = `${getters.api}/sms-account/forward`

            //  Send the reuqest
            return window.axios.delete(url).then(response => {
                //  Return the updated sms account
                return response.data
            }).catch(() => null)
        },
        //  We no longer verify call forwarding numbers since we no longer use nexmo
        // smsAccountVerify ({ getters }, number: number): Promise<SmsAccount> {
        //     //  Assemble the API endpoint
        //     const url = `${getters.api}/sms-account/verify`

        //     //  Send the request
        //     return window.axios.post(url, number).then(response => {
        //         //  Return the updated sms account
        //         return response.data
        //     }).catch(() => null)
        // },
        tollFreeNumberProvision ({ commit, getters }): Promise<SmsAccount> {
            //  Assemble the API endpoint
            const url = `${getters.api}/sms-account/toll-free`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Update our sms account
                commit('smsAccountSet', response.data)

                //  Return the updated sms account
                return response.data
            }).catch(() => null)
        }
    },
    getters: {
        availableNumbers (state: State): number[] {
            return state.availableNumbers
        },
        smsAccount (state: State): SmsAccount {
            return state.smsAccount
        },
        smsAccountHasNumber (state: State): boolean {
            // No smsAccount available
            if(state.smsAccount === null) return false

            // Else, returns `true` when a number is set
            return state.smsAccount.msisdn != null
        }
    }
}
